export const detectAssetMaintenanceIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE asset maintenance
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(asset maintenance)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("asset") &&
        cleaned.includes("maintenance") 
    ) {
        return {
            intent: "delete_asset_maintenance",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE asset maintenance
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(asset maintenance)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("asset") &&
        cleaned.includes("maintenance") 
    ) { 
        return {
            intent: "create_asset_maintenance",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
